// src/context/AdminUsersContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';
import { getUsers, getListingsByUserId } from '../services/api';

const AdminUsersContext = createContext(null);

export const AdminUsersProvider = ({ children }) => {
    const [users, setUsers] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [userRolesMap, setUserRolesMap] = useState({});

    // 純資料抓取邏輯（不含 UI loading）
    // 分批抓 listingCount（一次最多 6 個並發），避免塞滿瀏覽器連線池卡住其他頁面的 API
    const refetchUsers = async () => {
        const token = localStorage.getItem('authToken');
        const apiUsers = await getUsers();

        const CHUNK_SIZE = 6;
        const withCounts = [];
        for (let i = 0; i < apiUsers.length; i += CHUNK_SIZE) {
            const chunk = apiUsers.slice(i, i + CHUNK_SIZE);
            const chunkResults = await Promise.all(
                chunk.map(async (u) => {
                    try {
                        const listings = await getListingsByUserId(u.Id, token);
                        return { ...u, listingCount: listings.length };
                    } catch {
                        return { ...u, listingCount: 0 };
                    }
                })
            );
            withCounts.push(...chunkResults);
        }
        return withCounts;
    };

    const value = useMemo(() => ({
        users,
        setUsers,
        hasFetched,
        setHasFetched,
        refetchUsers,
        userRolesMap,
        setUserRolesMap,
    }), [users, hasFetched, userRolesMap]);

    return (
        <AdminUsersContext.Provider value={value}>
            {children}
        </AdminUsersContext.Provider>
    );
};

export const useAdminUsers = () => {
    const ctx = useContext(AdminUsersContext);
    if (!ctx) throw new Error('useAdminUsers must be used within AdminUsersProvider');
    return ctx;
};